import { PaymentMethodType } from "ts/api/paymentMethod";
import { CartTotalAmount } from "store/exhibitors/cartStepper/helper";

export { MIN_AMOUNT_BY_CURRENCY } from "@evennt-tech/api-v2-core";

export const tabs = [
  {
    label: "exhibitor.cart.payment.tab.card",
  },
  {
    label: "exhibitor.cart.payment.tab.bank_transfer",
  },
] as const;

export const paymentMethods = [
  PaymentMethodType.cardPayment,
  PaymentMethodType.bankTransfer,
] as const;

export const calculateTotal = (cartTotal: CartTotalAmount) => {
  if (!cartTotal.withApproval) {
    return cartTotal.withoutApproval;
  }
  return (
    Object.entries(cartTotal.withApproval).reduce<number>(
      (acc, [_, total]) => acc + total,
      0
    ) + cartTotal.withoutApproval || 0
  );
};

export const INVOICE_DESCRIPTION_LIMIT = 500;
